/* APP */
import 'popper.js';
import 'bootstrap';
import '@fortawesome/fontawesome-pro/js/all';
import 'owl.carousel';
import { Map } from './map';

/* WADCMS
A décommenter si vous utilisez WadCms */
/* import '../../vendor/wad-commons/wad-cms/assets/js/app-cms'; */

/* WADGALLERY
A décommenter si vous utilisez WadGallery */
import '../../vendor/wad-commons/wad-gallery/assets/js/app-gallery';

$(document).ready(function() {
	carousel();
	loadMap();
});
function carousel() {
	$('.owl-partners').owlCarousel({
	    loop: false,
	    margin: 0,
	    dots: true,
	    nav: false,
	    autoplay: true,
	    //items: 7,
	    responsive:{
	        0:{
	            items:1,
	            loop:true,
	        },
	        600:{
	            items:3,
	            loop:true,
	        },
	        800:{
	            items:4,
	            loop:true,
	        },
	        1200:{
	            items:6,
	            autoplay:false,
	        }
	    }
	});
	
	$('.owl-testimonies').owlCarousel({
		loop: true,
        margin: 0,
        dots: true,
        nav: false,
        autoplay: true,
        items: 1,
	});
	
	$('.button-toggle').click(function(){
		$('.button-toggle').removeClass('active');
		$(this).addClass('active');
	});
}


function loadMap() {
		// GOOGLE MAP
	  // Places
	  let mapPlaceElement = document.getElementById('placemap'); 
	  if (mapPlaceElement){
	    Map.loadGoogleMapsApi().then(function(googleMaps) {
	      let map = Map.createMap(googleMaps, mapPlaceElement);
	      let dataTag = document.getElementById('data-places');
	      if (dataTag){
	        let data = JSON.parse(dataTag.innerHTML);
	        let places = data.places;
	        places.forEach((place) => {
	          Map.addMarker(googleMaps, map, place);
	        }) 
	      }
	    });
	  }
}
